import API from "./axios";

const transportLedgerApi = {
  getSummary:      ()                       => API.get("/transport-ledger/summaries"),
  getLedger:       (transportId)            => API.get(`/transport-ledger/${transportId}`),
  getLedgerRange:  (transportId, from, to)  => API.get(`/transport-ledger/${transportId}/range?from=${from}&to=${to}`),
  exportPdf:       (transportId, from, to)  => API.get(`/transport-ledger/${transportId}/pdf?from=${from}&to=${to}`, { responseType: "blob" }),
  deletePayment:   (ledgerId)               => API.delete(`/transport-ledger/entry/${ledgerId}`),
  recordPayment:   (data)                   => API.post(`/transport-ledger/${data.transportId}/payment`, {
    amount: data.amount,
    paymentDate: data.date,
    paymentMode: data.paymentMode,
    paymentReference: data.paymentReference,
    notes: data.notes,
  }),
};

export default transportLedgerApi;